export default {
    // récuperer toutes les users dans la base de données 
    get_all_account() {
        return axios.get('/dashbord/getsoldecaisse', {
            headers: {
                Authorization: "Bearer " + token
            }
        })
    }

}